import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { graphql, compose } from "react-apollo";
import { gql } from "apollo-boost";
import NewJobForm from "./NewJobForm";
import JobsList from "./JobsList";
// import { JobsQuery } from "./Jobs";

class NewJob extends React.Component {
  handleSubmit = ({ copyMailingAddress, ...values }) => {
    if (copyMailingAddress) {
      values.jobSite = {
        ...values.contact.address
      };
    }

    return this.props
      .createJob({ input: values })
      .then(({ data: { createJob } }) => {
        const { match, history } = this.props;
        history.push(match.url.replace("/new", `/${createJob.id}`));
      })
      .catch(error =>
        console.error("there was a problem creating this job", error)
      );
  };

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>New Job</title>
        </Helmet>
        <NewJobForm
          franchise={this.props.franchise}
          onSubmit={this.handleSubmit}
        />
      </Fragment>
    );
  }
}

const CreateJobMutation = gql`
  mutation CreateJobMutation($input: JobInput!) {
    createJob(input: $input) {
      ...JobsListJob
    }
  }
  ${JobsList.fragments.job}
`;

const enhance = compose(
  graphql(CreateJobMutation, {
    props({ ownProps, mutate }) {
      return {
        createJob({ input }) {
          return mutate({
            variables: { input }
          });
        }
      };
    }
  })
);

export default enhance(NewJob);



// WEBPACK FOOTER //
// ./src/components/NewJob.js